import { put, takeEvery, call, select } from 'redux-saga/effects';
import { showNotification } from 'react-admin';
import axios from 'axios';
import get from 'lodash/get';
import {
  getProfile,
  getProfileSuccess,
  getProfileFailure,
  resetProfile as resetProfileAction,
  types as profileTypes
} from './profileActions';

const API_URL = 'v1';

/**
 * Retrieve profile of the user connected
 * @param {*} action
 */
export function* retrieveProfile(action) {
  // Avoid to throw same action (GET and REFRESH)
  if (!action || action.type !== profileTypes.REFRESH_PROFILE) {
    yield put(getProfile());
  }
  const token = sessionStorage.getItem('token');
  const tenant = sessionStorage.getItem('tenant');

  // Call to /v1/user without a userId will fecth the logged in user profile
  var request = {
    method: 'GET',
    url: API_URL + '/user',
    headers: {
      'Content-Type': 'application/json',
      'IC-USER-CLIENT': Buffer.from(tenant).toString('base64'),
      'X-IC-ACCESS-TOKEN': token
    }
  };

  try {
    const resp = yield call(axios.request, request);

    yield put(getProfileSuccess(resp.data));
  } catch (error) {
    let notId = 'ra.page.error';
    let param = {};
    const message = get(error, 'response.data.errorMessage');
    if (message) {
      notId = 'ra.notification.server';
      param = { messageArgs: { message: message } };
    }
    yield put(getProfileFailure(message));
    yield put(showNotification(notId, 'error', param));
  }
}

/**
 * Reset the profile when the user is logout
 */
export function* resetProfile() {
  const profile = yield select(state => state.profile.item);
  // If there is no profile anymore, avoid to dispatch an event to reset the profile again
  if (profile) {
    yield put(resetProfileAction());
  }
}

/**
 * Retrieve the profile of the user connected for the first time
 */
export function* firstRetrieveProfile() {
  const token = sessionStorage.getItem('token');
  const isLoading = yield select(state => state.profile.loading);
  const error = yield select(state => state.profile.error);
  const profile = yield select(state => state.profile.item);

  if (token && !isLoading && !profile && !error) {
    yield retrieveProfile();
  }
}

/**
 * Main Saga to manage the profile of the user connected
 */
export default function* profileSaga() {
  yield takeEvery(
    ({ type }) => type === 'RA/REGISTER_RESOURCE',
    firstRetrieveProfile
  );
  yield takeEvery('RA/CLEAR_STATE', resetProfile);
  yield takeEvery('REFRESH_PROFILE', retrieveProfile);
}
